import propOr from 'lodash/fp/propOr'
import { IShop } from '@cbgms/api/modules/shops'
import { IRootReducerState } from 'state/rootReducer'
import { WorkorderLineStatus } from '@cbgms/api/modules/enums'
import { hasPermission } from 'utils/Subscription/RequiredPermissions'
import { PERMISSION_ONLY_PORTAL } from 'utils/Subscription/PermissionComposites'
import { PERMISSION_WORKORDERLINE_STATUS_TOGGLE } from 'utils/Subscription/Permissions'
import { IWorkorder, WorkorderLineState } from '@cbgms/api'

export const initialShopValues = (state: IRootReducerState): IShop => propOr({}, 'auth.shop', state)

export const getInitialLineStatus = (state: IRootReducerState): WorkorderLineStatus => {
  // if the shop doens't have the permission to toggle the workorderline states, it should be on approved by default.
  if (!hasPermission(state.auth.shop.Modules, PERMISSION_WORKORDERLINE_STATUS_TOGGLE, state.auth.permissionExtension.modifiedPermissions)) {
    return WorkorderLineStatus.Approved
  }
  return WorkorderLineStatus.Quotation
}

export const getOrderOrWorkorderLines = (state: IRootReducerState): WorkorderLineState[] => {
  // If an order and not a workorder
  if (hasPermission(state.auth.shop.Modules, PERMISSION_ONLY_PORTAL, state.auth.permissionExtension.modifiedPermissions)) {
    return state.order.lines
  }
  return state.workorder.lines
}

export const getOrderOrWorkorder = (state: IRootReducerState): IWorkorder => {
  // If an order and not a workorder
  if (hasPermission(state.auth.shop.Modules, PERMISSION_ONLY_PORTAL, state.auth.permissionExtension.modifiedPermissions)) {
    return state.order.details.Workorder
  }
  return state.workorder.details
}
